/**
 * @file 是否是手机端
 * @author hanzhichen(hanzhichen@baijiahulian.com)
 * @date 2020-12-07
 */
import {isMobile} from '~/utils/agent';

export default {
    state: {
        isMobile: false,
    },

    action: {
        updateIsMobile() {
            return {isMobile: isMobile()};
        }
    },

    reducer: {
        updateIsMobile(state, action, error) {
            if (!error) {
                const {isMobile} = action.payload;
                return {
                    isMobile
                };
            }
            return {...state};
        }
    }
};
